/*
 * ELLIZ size guide drawer logic  (v3 - 2026-08-27)
 *
 * Resolves a guide from product.type + tags (accent-insensitive), renders
 *   - "Σωματικές διαστάσεις" (body)      -> "hangi bedenim?"
 *   - "Διαστάσεις ρούχου"   (item, cm)   -> "urun kac cm?"  (body tablosunun ALTINDA)
 *   - "Βάρος -> μέγεθος"    (weight)     + boy/kilo hesaplayicisi
 * CM only. Only the sizes the product actually offers are shown (data-product-sizes).
 *
 * 2026-08-26 (v2) degisiklikleri:
 *  A) URUN BAZLI ELLE TABLO: product.metafields.custom.size_table dolu ise
 *     (drawer'a data-elliz-sg-table attribute'u ile gelir) o urunun body +
 *     weight tablolari VE hesaplayici TAMAMEN o metinden uretilir. Yarim
 *     override yok: kesim rehberi (item/body/weight/approx) tamamen devre disi.
 *  B) 'item' (cm) tablosu artik EKRANA BASILIYOR. Placeholder tablolar JSON'dan
 *     silindigi icin izin listesine gerek yok: veri yoksa basilacak sey de yok.
 *     'item' ASLA 'extends' ile devralinmaz (kesime ozgudur) -> denim sort artik
 *     loose jean'in 66 cm ic boyunu gostermez.
 *  C) 42/44 (chino_large) tuzagi: chino tablosu SADECE numarasi 38'den kucuk
 *     beden ICERMEYEN ve waistSizing (inc-bel) olmayan alt giyimde devreye girer.
 *  D) Urunun sundugu ama tabloda karsiligi olmayan beden -> durust not + chat.
 *     Hicbir tabloda eslesme yoksa tablo BASILMAZ (yanlis tablo > bos tablo).
 *
 * 2026-08-27 (v3) degisiklikleri:
 *  1) KILA / EKATOSTA artik SEKME degil IKI DURUMLU DUGME (segmented toggle).
 *     Ayni altyapi (data-elliz-sg-tab / -pane) korundu; yalnizca gorunum ve
 *     erisilebilirlik guncellendi: aria-selected + roving tabindex + ok tuslari.
 *     Veri tek tarafliysa serit HIC cizilmez (eski "both" kurali korundu).
 *     Cekmece her acildiginda varsayilan tabloya (genelde KILA) doner.
 *  2) Elle tablo attribute'u: data-elliz-sg-manual -> data-elliz-sg-table.
 *  3) parseManual daha katı: 'kg' yokken yalnizca 2 (olcu) veya 3 (olcu+kilo)
 *     deger kabul edilir; 4+ deger artik sessizce 3. sutunu kilo saymaz.
 *     Mukerrer beden 'bad' listesine yazilir; rakamsiz baslik satiri atlanir.
 *  4) Hesaplayici tablo araligi disinda kenara YAPISMAZ: "—" gosterir ve
 *     hangi yonde tastigini yazar.
 *  5) Notlar (approx / mnote / missing / nocm) sabit sirada basilir.
 *
 * Data:  assets/elliz-size-guides.json
 * Debug: ?sgdebug=1  -> elle tabloda okunamayan satirlari drawer'da gosterir.
 */
(function () {
  if (window.__ellizSgInit) return;
  window.__ellizSgInit = true;

  var DEBUG = /[?&]sgdebug=1/.test(window.location.search);

  var APPROX_NOTE = "* Κατά προσέγγιση — υπολογισμένες τιμές από τα γειτονικά μεγέθη.";
  var MANUAL_NOTE = "Οι διαστάσεις αφορούν αποκλειστικά αυτό το προϊόν.";
  var NO_CM_NOTE =
    "Χρειάζεσαι ακριβείς διαστάσεις σε εκατοστά; Γράψε μας στο chat (κάτω δεξιά) και θα σε βοηθήσουμε να διαλέξεις.";

  /* (D4) Hesaplayici artik tablonun disina TASMAZ. Eskiden 45 kg yazan musteriye
     tablonun en kucuk bedeni sessizce onerilirdi; artik "—" gosterilir ve neden
     oldugu yazilir. */
  var OOR_LOW = "Το βάρος είναι κάτω από τον πίνακα. Το μικρότερο διαθέσιμο μέγεθος είναι ";
  var OOR_HIGH = "Το βάρος είναι πάνω από τον πίνακα. Το μεγαλύτερο διαθέσιμο μέγεθος είναι ";
  var OOR_GAP =
    "Το βάρος πέφτει ανάμεσα στα διαθέσιμα μεγέθη. Γράψε μας στο chat (κάτω δεξιά) και θα σε βοηθήσουμε να διαλέξεις.";

  function normalize(s) {
    return (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  }
  function trim(s) {
    return String(s == null ? "" : s).replace(/^\s+|\s+$/g, "");
  }
  function upper(s) {
    return trim(s).toUpperCase();
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  /* Urun bedenlerini karsilastirma anahtarlarina acar:
     - "2XL"/"3XL" takma adlari XXL/XXXL satirlariyla eslesir,
     - "40-41" / "S-M" gibi ARALIK bedenleri iki ucuna acilir. */
  function sizeTokens(list) {
    var out = [];
    (list || []).forEach(function (raw) {
      var s = upper(raw);
      if (!s) return;
      if (s === "2XL") s = "XXL";
      if (s === "3XL") s = "XXXL";
      out.push(s);
      var parts = s.split("-");
      if (parts.length === 2 && trim(parts[0]) && trim(parts[1])) {
        var a = upper(parts[0]), b = upper(parts[1]);
        if (a === "2XL") a = "XXL";
        if (b === "2XL") b = "XXL";
        out.push(a);
        out.push(b);
      }
    });
    return out;
  }

  function resolveGuideKey(data, type, tags) {
    var hay = normalize(type + " " + tags.join(" "));
    for (var i = 0; i < data.rules.length; i++) {
      var rule = data.rules[i];
      for (var j = 0; j < rule.match.length; j++) {
        if (hay.indexOf(normalize(rule.match[j])) !== -1) return rule.key;
      }
    }
    return data.default || "bottomwear";
  }

  /* "extends" ile body/weight/approx/waistSizing DEVRALINIR, 'item' ASLA.
     'item' = o kesimin dikilmis olculeri; devralinirsa yanlis cm yayinlanir
     (shorts_denim -> jeans_loose "Εσωτ. σκέλος 66 εκ." hatasi). */
  function getGuide(data, key) {
    var g = data.guides[key] || data.guides[data.default];
    if (!g) return null;
    var base = g.extends && data.guides[g.extends] ? data.guides[g.extends] : null;
    var out = {};
    if (base) Object.keys(base).forEach(function (k) { out[k] = base[k]; });
    Object.keys(g).forEach(function (k) { if (g[k] != null) out[k] = g[k]; });
    out.item = g.item || null;
    delete out.extends;
    return out;
  }

  function weightRowsAll(w) {
    if (!w) return [];
    if (Array.isArray(w)) return w;
    var out = [];
    Object.keys(w).forEach(function (k) { (w[k] || []).forEach(function (r) { out.push(r); }); });
    return out;
  }

  /* Harfli rehberlerde urunun EN BUYUK bedenine gore kilo tablosunu sec. */
  function pickWeight(guide, sizes) {
    var w = guide.weight;
    if (!w) return null;
    if (Array.isArray(w)) return w;
    var order = ["S", "M", "L", "XL", "XXL"];
    var mi = -1, maxSize = null;
    (sizes || []).forEach(function (s) { var i = order.indexOf(s); if (i > mi) { mi = i; maxSize = s; } });
    if (maxSize && w[maxSize]) return w[maxSize];
    var keys = Object.keys(w).filter(function (k) { return order.indexOf(k) !== -1; })
      .sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
    if (!keys.length) return null;
    if (mi < 0) return w[keys[keys.length - 1]];
    var best = keys[0];
    keys.forEach(function (k) { if (order.indexOf(k) <= mi) best = k; });
    return w[best];
  }

  function guideSizes(g) {
    var s = [];
    weightRowsAll(g.weight).forEach(function (w) { s.push(upper(w.size)); });
    if (g.item && g.item.rows) g.item.rows.forEach(function (r) { s.push(upper(r[0])); });
    if (g.body && g.body.rows) g.body.rows.forEach(function (r) { s.push(upper(r[0])); });
    return s;
  }
  function guideMatchesSizes(g, sizes) {
    if (!sizes || !sizes.length) return true;
    var gs = guideSizes(g);
    return sizes.some(function (s) { return gs.indexOf(upper(s)) !== -1; });
  }

  function headerLabel(col) {
    return col.unit ? col.label + " (εκ.)" : col.label;
  }

  /* Urunun sundugu bedenlere sus. Hicbiri eslesmiyorsa BOS don:
     yanlis bir tablo gostermektense hic gostermemek dogru. */
  function filterRows(rows, sizes) {
    if (!rows) return [];
    if (!sizes || !sizes.length) return rows;
    return rows.filter(function (r) { return sizes.indexOf(upper(r[0])) !== -1; });
  }
  function filterWeights(rows, sizes) {
    if (!rows) return [];
    if (!sizes || !sizes.length) return rows;
    return rows.filter(function (r) { return sizes.indexOf(upper(r.size)) !== -1; });
  }

  /* ---------- tablo cizimi ---------- */

  function tableHtml(spec, sizes, approx) {
    var res = { html: "", sizes: [], approx: false };
    if (!spec || !spec.columns || !spec.rows) return res;
    var rows = filterRows(spec.rows, sizes);
    if (!rows.length) return res;
    var h = "<table class='elliz-sg-table'>";
    if (spec.caption) h += "<caption>" + esc(spec.caption) + "</caption>";
    h += "<thead><tr>";
    spec.columns.forEach(function (c) { h += "<th>" + esc(headerLabel(c)) + "</th>"; });
    h += "</tr></thead><tbody>";
    rows.forEach(function (row) {
      var lbl = upper(row[0]);
      res.sizes.push(lbl);
      var isA = !!(approx && approx.indexOf(lbl) !== -1);
      if (isA) res.approx = true;
      h += "<tr>";
      row.forEach(function (cell, i) { h += "<td>" + esc(cell) + (i === 0 && isA ? " *" : "") + "</td>"; });
      h += "</tr>";
    });
    res.html = h + "</tbody></table>";
    return res;
  }

  function weightTableHtml(rows, approx) {
    var res = { html: "", sizes: [], approx: false };
    if (!rows || !rows.length) return res;
    var h = "<table class='elliz-sg-table'><thead><tr><th>Βάρος (kg)</th><th>Προτεινόμενο μέγεθος</th></tr></thead><tbody>";
    rows.forEach(function (r) {
      var lbl = upper(r.size);
      res.sizes.push(lbl);
      var isA = !!(approx && approx.indexOf(lbl) !== -1);
      if (isA) res.approx = true;
      h += "<tr><td>" + esc(r.min + " - " + r.max) + "</td><td>" + esc(r.size) + (isA ? " *" : "") + "</td></tr>";
    });
    res.html = h + "</tbody></table>";
    return res;
  }

  /* Tabloda karsiligi yoksa BOS doner; cagiran taraf "—" basar. */
  function weightSize(rows, kg) {
    if (!rows || !rows.length || !(kg > 0)) return "";
    for (var i = 0; i < rows.length; i++) {
      if (kg >= rows[i].min && kg <= rows[i].max) return rows[i].size;
    }
    return "";
  }

  /* ---------- notlar ---------- */

  function clearNotes(root) {
    if (!root) return;
    root.querySelectorAll(".elliz-sg-approx,.elliz-sg-mnote,.elliz-sg-missing,.elliz-sg-nocm")
      .forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
  }
  function noteEl(cls, text) {
    var p = document.createElement("p");
    p.className = "elliz-sg-tip " + cls;
    p.textContent = text;
    return p;
  }
  /* (D5) Ayni kutunun altina birden fazla not girince sira TERSINE donuyordu
     (her yeni not dogrudan tablonun hemen altina giriyordu). Artik notlar once
     toplanir, sonra cagri sirasindan bagimsiz SABIT sirayla basilir:
     yaklasik (*) -> "sadece bu urun" -> eksik beden -> cm yok. */
  var NOTE_RANK = { "elliz-sg-approx": 1, "elliz-sg-mnote": 2, "elliz-sg-missing": 3, "elliz-sg-nocm": 4 };
  function noteQueue() {
    var items = [], seq = 0;
    return {
      add: function (node, cls, text) {
        if (!node || !text) return;
        items.push({ node: node, cls: cls, text: text, rank: NOTE_RANK[cls] || 9, seq: seq++ });
      },
      flush: function () {
        items.sort(function (a, b) { return (a.rank - b.rank) || (a.seq - b.seq); });
        var cursors = [];
        items.forEach(function (it) {
          if (!it.node || !it.node.parentNode) return;
          var rec = null, i;
          for (i = 0; i < cursors.length; i++) { if (cursors[i].node === it.node) rec = cursors[i]; }
          if (!rec) { rec = { node: it.node, at: it.node }; cursors.push(rec); }
          var el = noteEl(it.cls, it.text);
          rec.at.parentNode.insertBefore(el, rec.at.nextSibling);
          rec.at = el;
        });
        items = [];
      }
    };
  }

  /* Urunun sundugu ama tabloda karsiligi olmayan bedenler. */
  function missingList(rawSizes, covered) {
    var out = [];
    (rawSizes || []).forEach(function (raw) {
      var ok = sizeTokens([raw]).some(function (t) { return covered.indexOf(t) !== -1; });
      if (!ok && out.indexOf(raw) === -1) out.push(raw);
    });
    return out;
  }
  function missingText(list) {
    var head = list.length === 1
      ? "Δεν έχουμε ακόμη αναλυτικά στοιχεία για το μέγεθος " + list[0] + "."
      : "Δεν έχουμε ακόμη αναλυτικά στοιχεία γι' αυτά τα μεγέθη: " + list.join(", ") + ".";
    return head + " Γράψε μας στο chat (κάτω δεξιά) και θα σε βοηθήσουμε να διαλέξεις.";
  }

  /* ---------- ELLE TABLO (product.metafields.custom.size_table) ---------- */

  var ORD = ["XS", "S", "M", "L", "XL", "XXL", "XXXL"];
  var SIZE_RE = /^[A-Z0-9][A-Z0-9./-]{0,6}$/;
  var DASH = /[\-‐‑‒–—―−]+/;

  function sizeRank(s) {
    if (/^\d+(\.\d+)?$/.test(s)) return parseFloat(s);
    var i = ORD.indexOf(s);
    return i < 0 ? 9999 : 1000 + i;
  }
  function normSize(s) {
    var v = upper(s);
    if (v === "2XL") v = "XXL";
    if (v === "3XL") v = "XXXL";
    return v;
  }
  function isKgCell(s) {
    return /kg/i.test(s) || normalize(s).indexOf("κιλ") !== -1;
  }

  /* Sutun ayraci. Virgul SADECE rakamlar arasinda dogrudan gecmiyorsa ayrac
     sayilir ("42 , 111-116" evet; "120,5" ve "42,111" hayir) -> ondalik virgul
     ile catismaz. Cozulemeyen satir sessizce OLMEZ, "bad" listesine yazilir. */
  function splitCells(line) {
    if (/[|;\t]/.test(line)) return line.split(/[|;\t]+/);
    if (line.indexOf(",") !== -1 && !/\d,\d/.test(line)) return line.split(",");
    return null;
  }

  function parseRange(s) {
    var t = String(s).replace(/,/g, ".").replace(/[^\d.\-‐-―−]/g, "");
    var p = t.split(DASH), n = [];
    for (var i = 0; i < p.length; i++) {
      if (p[i] === "") continue;
      var f = parseFloat(p[i]);
      if (!isNaN(f)) n.push(f);
    }
    if (!n.length) return null;
    var a = n[0], b = n.length > 1 ? n[1] : a;
    return { min: Math.min(a, b), max: Math.max(a, b) };
  }

  function parseManual(text) {
    var res = { dims: [], wts: [], bad: [], maxDim: 0 };
    if (!text) return res;
    var lines = String(text).split(/\r?\n/), seenD = {}, seenW = {}, i, j;
    for (i = 0; i < lines.length; i++) {
      var line = trim(lines[i]);
      if (!line || line.charAt(0) === "#") continue;
      /* (D8) Baslik satiri ("ΜΕΓΕΘΟΣ | ΜΕΣΗ | ΓΟΦΟΙ") ve benzeri rakamsiz
         gurultu hata degildir: sessizce atlanir, kirmizi uyari uretmez. */
      if (!/[0-9]/.test(line)) continue;
      var cells = splitCells(line);
      if (!cells) { res.bad.push(line); continue; }
      var c = [];
      for (j = 0; j < cells.length; j++) { var v = trim(cells[j]); if (v) c.push(v); }
      if (c.length < 2) { res.bad.push(line); continue; }
      var size = normSize(c[0]);
      if (!SIZE_RE.test(size)) { res.bad.push(line); continue; }
      var vals = c.slice(1), kg = null, rest = [], hasDigit = false;
      for (j = 0; j < vals.length; j++) {
        if (/\d/.test(vals[j])) hasDigit = true;
        if (kg === null && isKgCell(vals[j])) kg = vals[j];
        else rest.push(vals[j]);
      }
      if (!hasDigit) { res.bad.push(line); continue; }
      /* (D1) 'kg' yazilmamissa TAHMIN ETME. Yalnizca iki kalip kabul edilir:
           BEDEN | ΜΕΣΗ | ΓΟΦΟΙ           -> 2 deger, kilo yok
           BEDEN | ΜΕΣΗ | ΓΟΦΟΙ | KILO    -> 3 deger, sonuncusu kilo
         Bundan fazlasi (ya da tek deger) okunamadi sayilir. Eskiden 4+ degerli
         satirda 3. sutun KOSULSUZ kilo kabul ediliyordu:
         "42 | 111-116 | 123-127 | 60 | 80 | 120-130" satiri musteriye
         "60 kg -> 42" olarak yayinlaniyordu, tek bir uyari bile cikmadan.
         'kg' yazili satirlarda da fazla sutun artik sessizce kirpilmaz. */
      if (kg === null) {
        if (rest.length === 3) { kg = rest[2]; rest = rest.slice(0, 2); }
        else if (rest.length !== 2) { res.bad.push(line); continue; }
      } else {
        if (rest.length > 2) { res.bad.push(line); continue; }
      }
      /* (D7) Ayni beden iki kez yazilmissa ikincisi sessizce YUTULMAZ. */
      var dup = false;
      if (rest.length) {
        if (seenD[size]) { dup = true; }
        else {
          seenD[size] = 1;
          res.dims.push([size].concat(rest));
          if (rest.length > res.maxDim) res.maxDim = rest.length;
        }
      }
      if (kg) {
        var r = parseRange(kg);
        if (!r) { res.bad.push(line); continue; }
        if (seenW[size]) { dup = true; }
        else { seenW[size] = 1; res.wts.push({ min: r.min, max: r.max, size: size }); }
      }
      if (dup) res.bad.push(line);
    }
    res.dims.sort(function (a, b) { return sizeRank(a[0]) - sizeRank(b[0]); });
    res.wts.sort(function (a, b) { return a.min - b.min; });
    return res;
  }

  /* (D2) Attribute adi data-elliz-sg-manual -> data-elliz-sg-table.
     Eski ad, CDN'de kalmis bayat bir drawer HTML'i icin geriye donuk okunur. */
  function readManual(container) {
    var raw = container.getAttribute("data-elliz-sg-table") ||
      container.getAttribute("data-elliz-sg-manual");
    if (!raw) return "";
    try {
      var v = JSON.parse(raw);
      return typeof v === "string" ? v : "";
    } catch (e) { return raw; }
  }

  function manualGuide(base, m) {
    var body = null;
    if (m.dims.length) {
      var cols = [{ label: "Μέγεθος" }, { label: "Μέση", unit: "cm" }];
      if (m.maxDim > 1) cols.push({ label: "Γοφοί", unit: "cm" });
      var rows = m.dims.map(function (r) {
        var out = [r[0], r[1] == null ? "—" : r[1]];
        if (m.maxDim > 1) out.push(r[2] == null ? "—" : r[2]);
        return out;
      });
      body = { caption: "Σωματικές διαστάσεις", columns: cols, rows: rows };
    }
    return {
      title: base.title,
      category: base.category || "bottom",
      manual: true,
      item: null,
      approx: null,
      body: body,
      weight: m.wts.length ? m.wts : null
    };
  }

  /* ---------- sekmeler ---------- */

  function setTabAvailable(drawer, name, ok) {
    var tab = drawer.querySelector("[data-elliz-sg-tab='" + name + "']");
    if (tab) tab.hidden = !ok;
    if (!ok) {
      var pane = drawer.querySelector("[data-elliz-sg-pane='" + name + "']");
      if (pane) pane.hidden = true;
    }
  }
  /* ΚΙΛΑ / ΕΚΑΤΟΣΤΑ dugmesi: gorsel olarak sekme degil iki durumlu dugme, ama
     islevi hala tablist -> aria-selected + roving tabindex ekran okuyucuya ve
     klavyeye dogru bilgiyi verir. */
  function selectTab(drawer, name) {
    drawer.querySelectorAll("[data-elliz-sg-tab]").forEach(function (t) {
      var on = t.getAttribute("data-elliz-sg-tab") === name;
      t.classList.toggle("is-active", on);
      t.setAttribute("aria-selected", on ? "true" : "false");
      t.setAttribute("tabindex", on ? "0" : "-1");
    });
    drawer.querySelectorAll("[data-elliz-sg-pane]").forEach(function (p) {
      p.hidden = p.getAttribute("data-elliz-sg-pane") !== name;
    });
  }
  /* Varsayilan tablo: kilo tablosu varsa ΚΙΛΑ, yoksa gorunen ilk secenek. */
  function defaultTabName(drawer) {
    var want = drawer.__ellizSgDefaultTab || "weight";
    var t = drawer.querySelector("[data-elliz-sg-tab='" + want + "']");
    if (t && !t.hidden) return want;
    var vis = [].slice.call(drawer.querySelectorAll("[data-elliz-sg-tab]"))
      .filter(function (x) { return !x.hidden; });
    return vis.length ? vis[0].getAttribute("data-elliz-sg-tab") : want;
  }
  function showOne(container, attr, value, fallback) {
    var nodes = container.querySelectorAll("[" + attr + "]");
    var matched = false;
    nodes.forEach(function (n) {
      var on = n.getAttribute(attr) === value;
      n.hidden = !on;
      if (on) matched = true;
    });
    if (!matched && fallback) {
      nodes.forEach(function (n) { n.hidden = n.getAttribute(attr) !== fallback; });
    }
  }

  /* ---------- kurulum ---------- */

  function setup(container, data) {
    var type = container.getAttribute("data-product-type") || "";
    var tags = (container.getAttribute("data-product-tags") || "").split(",").map(trim);
    var rawSizes = (container.getAttribute("data-product-sizes") || "").split(",").map(trim).filter(Boolean);
    var sizes = sizeTokens(rawSizes);

    var guideKey = resolveGuideKey(data, type, tags);
    var guide = getGuide(data, guideKey);
    if (!guide) return;

    var manual = parseManual(readManual(container));
    var hasManual = !!(manual.dims.length || manual.wts.length);

    if (hasManual) {
      /* (A) Elle tablo TEK kaynak: kesim rehberi tamamen devre disi. */
      guide = manualGuide(guide, manual);
    } else {
      var rawGuide = data.guides[guideKey] || {};
      /* (C) chino_large SADECE 38'den kucuk numarasi olmayan, inc-bel
         (waistSizing) olmayan alt giyimde. 29-42 beden sunan bir LOOSE JEAN
         artik buraya DUSMEZ -> 78 kg musteriye 32 onerilir, 40 degil. */
      var nums = [];
      sizes.forEach(function (s) { if (/^\d+$/.test(s)) nums.push(parseInt(s, 10)); });
      var big = nums.indexOf(42) !== -1 || nums.indexOf(44) !== -1;
      var minNum = nums.length ? Math.min.apply(null, nums) : null;
      var chinoOk = !rawGuide.waistSizing && guide.category === "bottom" &&
        big && minNum !== null && minNum >= 38;
      if (chinoOk && data.guides.chino_large && data.guides.chino_large.weight) {
        guide = {
          title: guideKey === "shorts" ? "Βερμούδες" : "Παντελόνια",
          category: "bottom",
          item: null,
          body: null,
          approx: null,
          weight: data.guides.chino_large.weight
        };
      } else if (sizes.length && !guideMatchesSizes(guide, sizes)) {
        /* Beden-tipi guvenlik agi: harfli urun -> harfli rehber,
           rakamli urun -> numericAlt (varsayilan jeans_loose). */
        var sizesNumeric = sizes.some(function (s) { return /^\d+$/.test(s); });
        var fbKey = (sizesNumeric && guide.category === "bottom")
          ? (rawGuide.numericAlt || "jeans_loose")
          : (guide.category === "top" ? "topwear" : (guide.category === "shoes" ? "shoes" : "bottomwear"));
        var fbGuide = getGuide(data, fbKey);
        if (fbGuide && guideMatchesSizes(fbGuide, sizes)) guide = fbGuide;
      }
    }

    var category = guide.category || "bottom";
    var embedded = !hasManual && container.getAttribute("data-embedded-guide") === "1";
    container._ellizSg = {
      guide: guide, sizes: sizes, rawSizes: rawSizes,
      embedded: embedded, manual: hasManual
    };

    var drawer = container.closest("[data-elliz-sg-drawer]") || document;

    var titleEl = drawer.querySelector("[data-elliz-sg-guide-title]");
    if (titleEl && guide.title) titleEl.textContent = guide.title;

    var emb = container.querySelector("[data-elliz-sg-embedded]");
    if (emb) emb.hidden = !embedded;

    clearNotes(container);
    var notes = noteQueue();

    /* --- ΚΙΛΑ (kilo -> beden) --- */
    var wPane = container.querySelector("[data-elliz-sg-pane='weight']");
    var wWrap = container.querySelector("[data-elliz-sg-weight-table]");
    var wRows = filterWeights(pickWeight(guide, sizes), sizes);
    var wOut = weightTableHtml(wRows, guide.approx);
    if (wWrap) { wWrap.innerHTML = wOut.html; wWrap.hidden = !wOut.html; }
    var hasWeight = !!wOut.html;
    if (hasWeight && wOut.approx) notes.add(wWrap, "elliz-sg-approx", APPROX_NOTE);

    /* --- ΕΚΑΤΟΣΤΑ: once ΣΩΜΑ (musterinin olcusu), sonra ΡΟΥΧΟ (urunun olcusu).
       "Hangi bedenim?" sorusunu vucut tablosu cevaplar, o yuzden ustte durur;
       urunun dikilmis olculeri ayri baslikla (JSON'daki caption) altinda gelir. --- */
    var bWrap = container.querySelector("[data-elliz-sg-body-table]");
    var iWrap = container.querySelector("[data-elliz-sg-item-table]");
    var bOut = { html: "", sizes: [], approx: false };
    var iOut = { html: "", sizes: [], approx: false };
    if (!embedded) {
      bOut = tableHtml(guide.body, sizes, guide.approx);
      iOut = tableHtml(guide.item, sizes, guide.approx);
    }
    if (bWrap) { bWrap.innerHTML = bOut.html; bWrap.hidden = !bOut.html; }
    if (iWrap) { iWrap.innerHTML = iOut.html; iWrap.hidden = !iOut.html; }
    /* FIX-1: ayni cumle ayni panoda iki kez basiliyordu (body + item). Tek not. */
    if ((bOut.approx || iOut.approx) && (bOut.html || iOut.html)) {
      notes.add(iOut.html ? iWrap : bWrap, "elliz-sg-approx", APPROX_NOTE);
    }
    if (hasManual) {
      if (bOut.html) notes.add(bWrap, "elliz-sg-mnote", MANUAL_NOTE);
      else if (hasWeight) notes.add(wWrap, "elliz-sg-mnote", MANUAL_NOTE);
    }

    var hasDims = embedded || !!bOut.html || !!iOut.html;

    /* (D) Tutarli "veri yok" kurali - her kategoride ayni sekilde calisir. */
    if (!embedded && hasDims) {
      var cov = bOut.sizes.concat(iOut.sizes);
      var dmiss = missingList(rawSizes, cov);
      if (dmiss.length && dmiss.length < rawSizes.length) {
        notes.add(iOut.html ? iWrap : bWrap, "elliz-sg-missing", missingText(dmiss));
      }
    }
    if (hasWeight) {
      var wmiss = missingList(rawSizes, wOut.sizes);
      if (wmiss.length && wmiss.length < rawSizes.length) {
        notes.add(wWrap, "elliz-sg-missing", missingText(wmiss));
      }
      if (!hasDims) notes.add(wWrap, "elliz-sg-nocm", NO_CM_NOTE);
    }
    /* Hicbir tablo yok: bos cekmece yerine durust bir cumle + chat. */
    if (!hasWeight && !hasDims && wPane) {
      hasWeight = true;
      if (wWrap) notes.add(wWrap, "elliz-sg-nocm", NO_CM_NOTE);
    }
    notes.flush();

    var bodyDiag = category === "shoes" ? "shoes" : (category === "bottom" ? "bottom" : "body");
    showOne(container, "data-elliz-sg-bodydiagram", bodyDiag, "body");

    setTabAvailable(drawer, "weight", hasWeight);
    setTabAvailable(drawer, "dims", hasDims);
    /* Selami'nin karari: TOGGLE VERI YOKSA HIC GORUNMESIN.
         kilo + cm  -> serit gorunur, ΚΙΛΑ secili
         yalniz kilo -> serit yok, kilo tablosu dogrudan (bugunku hal)
         yalniz cm   -> serit yok, cm tablosu dogrudan
       .elliz-sg-toolbar seridin DIS kutusudur (dolgu + alt cizgi); gizlenecek
       olan odur, yoksa bos bir bant kalir. */
    var both = hasWeight && hasDims;
    var toolbar = drawer.querySelector(".elliz-sg-toolbar");
    var tablabel = drawer.querySelector(".elliz-sg-tablabel");
    if (toolbar) toolbar.style.display = both ? "" : "none";
    if (tablabel) tablabel.style.display = both ? "" : "none";
    drawer.__ellizSgDefaultTab = hasWeight ? "weight" : "dims";
    selectTab(drawer, defaultTabName(drawer));

    /* --- hesaplayici: TEK kaynak (wRows), TEK dinleyici --- */
    var calc = drawer.querySelector("[data-elliz-sg-calc]");
    var rec = drawer.querySelector("[data-elliz-sg-rec]");
    var wIn = drawer.querySelector("[data-elliz-weight]");
    var hIn = drawer.querySelector("[data-elliz-height]");
    var oor = drawer.querySelector("[data-elliz-sg-oor]");
    if (drawer._ellizSgUpdate) {
      if (wIn) wIn.removeEventListener("input", drawer._ellizSgUpdate);
      if (hIn) hIn.removeEventListener("input", drawer._ellizSgUpdate);
      drawer._ellizSgUpdate = null;
    }
    if (oor) { oor.hidden = true; oor.textContent = ""; }
    if (wRows.length && calc && rec && wIn) {
      calc.hidden = false;
      var lo = wRows[0], hi = wRows[wRows.length - 1];
      var update = function () {
        var kg = parseInt(wIn.value, 10);
        if (!(kg > 0)) kg = 0;
        var size = weightSize(wRows, kg);
        rec.textContent = size || "—";
        if (!oor) return;
        if (size || !kg) { oor.hidden = true; oor.textContent = ""; return; }
        /* Tablonun altinda / ustunde / iki beden arasindaki bosluktayiz. */
        oor.hidden = false;
        oor.textContent = kg < lo.min ? (OOR_LOW + lo.size + ".")
          : (kg > hi.max ? (OOR_HIGH + hi.size + ".") : OOR_GAP);
      };
      /* FIX-2: on-dolu 78 kg tablonun disindaysa cekmece "—" ile aciliyordu
         (Hasan'in 100-130 kg tablolarinda HER acilista). Sadece ILK deger tabloya
         cekilir; musteri elle yazdiginda D4 uyarisi aynen calisir. */
      var kg0 = parseInt(wIn.value, 10);
      if (!(kg0 >= lo.min && kg0 <= hi.max)) {
        var mid = wRows[Math.floor(wRows.length / 2)];
        wIn.value = String(Math.round((mid.min + mid.max) / 2));
      }
      drawer._ellizSgUpdate = update;
      wIn.addEventListener("input", update);
      if (hIn) hIn.addEventListener("input", update);
      update();
    } else if (calc) {
      calc.hidden = true;
    }

    /* --- Hasan icin geri bildirim: okunamayan satirlar --- */
    if (manual.bad.length) {
      if (window.console && window.console.warn) {
        window.console.warn("[elliz-size-guide] custom.size_table: " + manual.bad.length +
          " satir okunamadi (| ile ayir, kilo icin 'kg' yaz):", manual.bad);
      }
      if (DEBUG) {
        var old = drawer.querySelector(".elliz-sg-dbg");
        if (old && old.parentNode) old.parentNode.removeChild(old);
        var box = document.createElement("div");
        box.className = "elliz-sg-note elliz-sg-dbg";
        box.style.cssText = "border-left-color:#c00;color:#c00;white-space:pre-line";
        var bn = manual.bad.length;
        box.textContent = "SG DEBUG - " + bn +
          (bn === 1 ? " γραμμή δεν αναγνωρίστηκε:" : " γραμμές δεν αναγνωρίστηκαν:") +
          "\n" + manual.bad.join("\n");
        var head = drawer.querySelector(".elliz-sg-drawer__head");
        if (head && head.parentNode) head.parentNode.insertBefore(box, head.nextSibling);
      }
    }
  }

  /* ---------- montaj / olaylar ---------- */

  function openDrawer(d) {
    if (d.parentElement !== document.body) document.body.appendChild(d);
    /* Selami'nin karari: secim HATIRLANMASIN — her acilista varsayilan tablo. */
    selectTab(d, defaultTabName(d));
    d.hidden = false;
    document.body.style.overflow = "hidden";
  }
  function closeDrawer(d) { d.hidden = true; document.body.style.overflow = ""; }

  /* Tema PDP'yi Section Rendering ile yeniden cizerse bolumun icinde IKINCI bir
     drawer (ve tetik butonu) olusur; kurulmus olani koru, yenisini kaldir. */
  function mount() {
    var list = [].slice.call(document.querySelectorAll("[data-elliz-sg-drawer]"));
    if (!list.length) return null;
    var keep = null;
    list.forEach(function (d) { if (d.__ellizMounted && !keep) keep = d; });
    if (!keep) { keep = list[0]; keep.__ellizMounted = true; }
    list.forEach(function (d) { if (d !== keep && d.parentNode) d.parentNode.removeChild(d); });
    if (keep.parentElement !== document.body) document.body.appendChild(keep);

    var trigs = [].slice.call(document.querySelectorAll(".elliz-sg-trigger"));
    if (trigs.length > 1) {
      var placed = trigs.filter(function (b) { return b.getAttribute("data-elliz-placed") === "1"; });
      var keepT = placed.length ? placed[placed.length - 1] : trigs[trigs.length - 1];
      trigs.forEach(function (b) { if (b !== keepT && b.parentNode) b.parentNode.removeChild(b); });
    }
    return keep;
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-elliz-sg-open]")) {
      var d = mount() || document.querySelector("[data-elliz-sg-drawer]");
      if (d) openDrawer(d);
      return;
    }
    if (e.target.closest("[data-elliz-sg-close]")) {
      var dc = e.target.closest("[data-elliz-sg-drawer]");
      if (dc) closeDrawer(dc);
      return;
    }
    var tab = e.target.closest("[data-elliz-sg-tab]");
    if (tab) {
      var panel = tab.closest("[data-elliz-sg-drawer]");
      /* Tek kod yolu: aria/tabindex senkronu selectTab'in isi. */
      if (panel) selectTab(panel, tab.getAttribute("data-elliz-sg-tab"));
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      var d = document.querySelector("[data-elliz-sg-drawer]:not([hidden])");
      if (d) closeDrawer(d);
      return;
    }
    /* ΚΙΛΑ / ΕΚΑΤΟΣΤΑ arasinda klavyeyle gecis (tablist standardi). */
    if (e.key !== "ArrowRight" && e.key !== "ArrowLeft" && e.key !== "Home" && e.key !== "End") return;
    var t = e.target && e.target.closest ? e.target.closest("[data-elliz-sg-tab]") : null;
    if (!t) return;
    var panel = t.closest("[data-elliz-sg-drawer]");
    if (!panel) return;
    var tabs = [].slice.call(panel.querySelectorAll("[data-elliz-sg-tab]"))
      .filter(function (x) { return !x.hidden; });
    if (tabs.length < 2) return;
    e.preventDefault();
    var i = tabs.indexOf(t), n;
    if (e.key === "Home") n = 0;
    else if (e.key === "End") n = tabs.length - 1;
    else n = (i + (e.key === "ArrowRight" ? 1 : tabs.length - 1)) % tabs.length;
    selectTab(panel, tabs[n].getAttribute("data-elliz-sg-tab"));
    tabs[n].focus();
  });

  var CACHE = null;

  function init() {
    var drawer = mount();
    if (!drawer) return;
    /* JSON adresini drawer'in data-elliz-sg-data'sindan (Liquid asset_url -> kendi
       ?v= surumu) al; yoksa eski yontem. script.src.replace tuzagi: JS degismeyince
       JSON eski ?v= ile istenir ve CDN bayat JSON dondurur (2026-07-02'de yasandi). */
    var script = document.querySelector('script[src*="elliz-size-guide.js"]');
    var dataUrl = drawer.getAttribute("data-elliz-sg-data") ||
      (script ? script.src.replace("elliz-size-guide.js", "elliz-size-guides.json") : "");
    if (!dataUrl) return;
    var run = function (data) {
      CACHE = data;
      document.querySelectorAll("[data-elliz-sg-body]").forEach(function (c) { setup(c, data); });
    };
    if (CACHE) { run(CACHE); return; }
    fetch(dataUrl).then(function (r) { return r.json(); }).then(run).catch(function () {});
  }

  document.addEventListener("shopify:section:load", function () { setTimeout(init, 0); });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
